import React from 'react';
import { Select, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import {
  DATE_FILTER_OPTIONS,
  RESTIGO_KIND_OPTIONS,
  RESTIGO_STATUS_OPTIONS,
  type DateFilterMode,
} from '../monitoring-page.constants';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type RestigoCallLogsFiltersProps = Pick<
  UseMonitoringPage,
  | 'restigoTenantFilter' | 'setRestigoTenantFilter'
  | 'restigoTenantOptions'
  | 'restigoKindFilter' | 'setRestigoKindFilter'
  | 'restigoStatusFilter' | 'setRestigoStatusFilter'
  | 'restigoSearch' | 'setRestigoSearch'
  | 'restigoDateFilterMode' | 'setRestigoDateFilterMode'
  | 'restigoExactDate' | 'setRestigoExactDate'
  | 'restigoDateFrom' | 'setRestigoDateFrom'
  | 'restigoDateTo' | 'setRestigoDateTo'
  | 'clearRestigoFilters'
>;

export const RestigoCallLogsFilters: React.FC<RestigoCallLogsFiltersProps> = ({
  restigoTenantFilter,
  setRestigoTenantFilter,
  restigoTenantOptions,
  restigoKindFilter,
  setRestigoKindFilter,
  restigoStatusFilter,
  setRestigoStatusFilter,
  restigoSearch,
  setRestigoSearch,
  restigoDateFilterMode,
  setRestigoDateFilterMode,
  restigoExactDate,
  setRestigoExactDate,
  restigoDateFrom,
  setRestigoDateFrom,
  restigoDateTo,
  setRestigoDateTo,
  clearRestigoFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGridKitchen}>
      <div className={classes.fieldStack}>
        <Select
          label={'עסק'}
          placeholder={'בחר עסק'}
          data={restigoTenantOptions}
          value={restigoTenantFilter || null}
          onChange={(value) => setRestigoTenantFilter(value ?? '')}
          searchable
          clearable
          data-testid="monitoring-restigo-filter-tenant"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'דוח'}
          placeholder={'בחר דוח'}
          data={RESTIGO_KIND_OPTIONS}
          value={restigoKindFilter || null}
          onChange={(value) => setRestigoKindFilter(value ?? '')}
          clearable
          data-testid="monitoring-restigo-filter-kind"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סטטוס'}
          placeholder={'בחר סטטוס'}
          data={RESTIGO_STATUS_OPTIONS}
          value={restigoStatusFilter || null}
          onChange={(value) => setRestigoStatusFilter(value ?? '')}
          clearable
          data-testid="monitoring-restigo-filter-status"
        />
      </div>

      <div className={classes.fieldStack}>
        <TextInput
          label={'חיפוש'}
          placeholder={'שגיאה או מספר הפעלה'}
          value={restigoSearch}
          onChange={(event) => setRestigoSearch(event.currentTarget.value)}
          data-testid="monitoring-restigo-filter-search"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סינון תאריך'}
          data={DATE_FILTER_OPTIONS}
          value={restigoDateFilterMode}
          onChange={(value) => setRestigoDateFilterMode((value as DateFilterMode) ?? 'all')}
          allowDeselect={false}
          data-testid="monitoring-restigo-date-mode"
        />
        {restigoDateFilterMode === 'exact' && (
          <TextInput type="date" value={restigoExactDate} onChange={(event) => setRestigoExactDate(event.currentTarget.value)} data-testid="monitoring-restigo-date-exact" />
        )}
        {restigoDateFilterMode === 'between' && (
          <div className={classes.fieldRow}>
            <TextInput type="date" value={restigoDateFrom} onChange={(event) => setRestigoDateFrom(event.currentTarget.value)} data-testid="monitoring-restigo-date-from" />
            <TextInput type="date" value={restigoDateTo} onChange={(event) => setRestigoDateTo(event.currentTarget.value)} data-testid="monitoring-restigo-date-to" />
          </div>
        )}
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearRestigoFilters} dataTestId="monitoring-restigo-clear-filters">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
